module.exports = __webpack_public_path__ + "static/transactionalemail-repeat-do-abe03bca61c4db75354bb7f247416ee6.png";